import React from 'react';
import { Button } from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import { useNavigate } from 'react-router-dom';
import {
  useTranslate,
} from 'react-admin'
export const MyDevicesButton = () => {
  const navigate = useNavigate()
   const translate = useTranslate()

  const handleNavigate = () => {
    navigate('/my-devices')
  }

  return (
    <>
      <Button
        onClick={handleNavigate}
        startIcon={<DevicesIcon />}
        style={{
          textTransform: 'none',
          justifyContent: 'flex-start',
          width: '100%',
          paddingLeft: '22px',
        }}
      >
        {translate('ra.title.my_devices')}
      </Button>
    </>
  )
};
